import { createPortal } from "react-dom";
import "./AlertWindow.scss";
import { useContext } from "react";
import { AppContext } from "../../Context/AppContext";
function AlertWindow(props) {
	const { theme } = useContext(AppContext);
	return createPortal(
		<div
			className='alert-window-wrapper'
			color={theme.color}
			style={{
				fontSize: `${(16 / theme.scaleFactor) * theme.fontMultiplier}px`,
			}}
		>
			<div className='alert-window'>
				<div>В окне ввода сообщения остались данные.</div>
				<div>Необходимо удалить их перед выходом.</div>
				<div>Удалить и выйти?</div>
				<div className='button-block'>
					<button
						className='yes-button'
						onClick={() => {
							if (props.inputRef.current) {
								props.inputRef.current.value = "";
							}
							props.setActiveContact(null);
							props.setAlertWindowOpen(false);
						}}
					>
						Да
					</button>
					<button
						className='no-button'
						onClick={() => props.setAlertWindowOpen(false)}
					>
						Нет
					</button>
				</div>
			</div>
		</div>,
		document.getElementById("addContact")
	);
}

export default AlertWindow;
